module.exports = __webpack_public_path__ + "img/25.08c31938.jpg";